export const SEARCH_AND_REPLACE_DIALOG_SELECTORS = {
   SEARCH_INPUT: '#searchText',
   REPLACE_INPUT: '#replaceText',
   SEARCH_RESULT_INDEX: '#searchResultIndex',
   SEARCH_RESULT_TOTAL: '#searchResultTotal',
} as const;